import { useContext } from 'react';
import { LanguageContext } from './languageContextDef';

/** Isolated hook file so Vite/React Fast Refresh does not invalidate every consumer when translations change. */
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
